export default "__VITE_ASSET__B86p6M7y__"